/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Metadata_Merge_FailedInputs */

const en_metadata_merge_failed = /** @type {(inputs: Metadata_Merge_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to merge metadata: ${i?.error}`)
};

const fr_metadata_merge_failed = /** @type {(inputs: Metadata_Merge_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de la fusion des métadonnées : ${i?.error}`)
};

const de_metadata_merge_failed = /** @type {(inputs: Metadata_Merge_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Metadaten konnten nicht zusammengeführt werden: ${i?.error}`)
};

const it_metadata_merge_failed = /** @type {(inputs: Metadata_Merge_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile unire i metadati: ${i?.error}`)
};

const ru_metadata_merge_failed = /** @type {(inputs: Metadata_Merge_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось объединить метаданные: ${i?.error}`)
};

const es_metadata_merge_failed = /** @type {(inputs: Metadata_Merge_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al fusionar los metadatos: ${i?.error}`)
};

const zh_cn2_metadata_merge_failed = /** @type {(inputs: Metadata_Merge_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`合并元数据失败：${i?.error}`)
};

const ja_metadata_merge_failed = /** @type {(inputs: Metadata_Merge_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`メタデータのマージに失敗しました: ${i?.error}`)
};

const hi_metadata_merge_failed = /** @type {(inputs: Metadata_Merge_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`मेटाडेटा को मर्ज करने में विफल: ${i?.error}`)
};

const pt_pt2_metadata_merge_failed = /** @type {(inputs: Metadata_Merge_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao mesclar metadados: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to merge metadata: {error}" |
*
* @param {Metadata_Merge_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_failed = /** @type {((inputs: Metadata_Merge_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_metadata_merge_failed(inputs)
	if (locale === "de") return de_metadata_merge_failed(inputs)
	if (locale === "it") return it_metadata_merge_failed(inputs)
	if (locale === "ru") return ru_metadata_merge_failed(inputs)
	if (locale === "es") return es_metadata_merge_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_metadata_merge_failed(inputs)
	if (locale === "ja") return ja_metadata_merge_failed(inputs)
	if (locale === "hi") return hi_metadata_merge_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_metadata_merge_failed(inputs)
	return en_metadata_merge_failed(inputs)
});